<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col md="12">
        <b-card header="Detalhes do movimento de hoje">
          <b-col sm="6" lg="4">
              <b-row>
                <b-col sm="6">
                  <Callout variant="info">
                    <small class="text-muted">Movimento da Conta</small><br>
                    <strong class="h4">{{$route.params.contaid}}</strong>
                  </Callout>
                </b-col>
                <b-col sm="6">
                  <Callout variant="warning">
                    <small class="text-muted">Saldo Inicial</small><br>
                    <strong class="h4">{{saldoInicial}}</strong>
                  </Callout>
                </b-col>
              </b-row>
              <hr class="mt-0">
          </b-col>
          <b-table  class="mb-0 table-outline" 
                    responsive="sm" 
                    hover 
                    :items="tableItemsContas" 
                    :fields="tableFieldsContas" 
                    head-variant="light">
            <div slot="historico" slot-scope="item">
              <div>
                {{item.value.value}}
              </div>
            </div>
            <div slot="centrocusto" slot-scope="item">
              <div>
                {{item.value.value}}
              </div>
            </div>
            <div slot="obs" slot-scope="item">
              <div>
                {{item.value.value}}
              </div>
            </div>
            <div slot="tipo" slot-scope="item">
              <div>
                {{item.value.value}}
              </div>
            </div>
            <div slot="credito" slot-scope="item">
              <div>
                {{item.value.value}}
              </div>
            </div>
            <div slot="debito" slot-scope="item">
              <div>
                {{item.value.value}}
              </div>
            </div>
            <div slot="saldo" slot-scope="item">
              <div>
                {{item.value.value}}
              </div>
            </div>
          </b-table>
          <b-col sm="8" lg="4">
              <b-row>
                <b-col sm="6">
                  <Callout variant="info">
                    <small class="text-muted">Total Créditos</small><br>
                    <strong class="h4">{{totalCredito}}</strong>
                  </Callout>
                </b-col>
                <b-col sm="6">
                  <Callout variant="danger">
                    <small class="text-muted">Total Débitos</small><br>
                    <strong class="h4">{{totalDebito}}</strong>
                  </Callout>
                </b-col>
                <b-col sm="6">
                  <Callout variant="warning">
                    <small class="text-muted">Saldo Final</small><br>
                    <strong class="h4">{{saldoFinal}}</strong>
                  </Callout>
                </b-col>
              </b-row>
              <hr class="mt-0">
          </b-col>
          
        </b-card>
          <b-btn type="button" variant="primary" @click="$router.go(-1)" ><i class="fa fa-arrow-left"></i> Voltar</b-btn>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { Callout } from '../../components/'
import VueButtonSpinner from '../../components/VueButtonSpinner.vue'

export default {
  name: 'dashboard',
  components: {
    Callout,
    VueButtonSpinner
  },
  data: function () {
    return {
      isLoading: false,
      status: '',
      submmited: false,
      saldoInicial: 'R$ 0,00',
      saldoFinal: 'R$ 0,00',
      totalCredito: 'R$ 0,00',
      totalDebito: 'R$ 0,00',
      tableItemsContas: [
        {
          _rowVariant: 'success',
          historico: { value: '' },
          centrocusto: { value: '' },
          obs: { value: '' },
          tipo: { value: '' },
          credito: { value: '0.00' },
          debito: { value: '0.00' },
          saldo: { value: '0.00' }
        }
      ],
      tableFieldsContas: {
        historico: {
          label: 'Historico'
        },
        centrocusto: {
          label: 'Centro Custo'
        },
        obs: {
          label: 'Observações'
        },
        tipo: {
          label: 'Tipo'
        },
        credito: {
          label: 'Crédito'
        },
        debito: {
          label: 'Débito'
        },
        saldo: {
          label: 'Saldo Atual'
        }
      }
    }
  },
  methods: {
    variant (value) {
      let $variant
      if (value <= 25) {
        $variant = 'info'
      } else if (value > 25 && value <= 50) {
        $variant = 'success'
      } else if (value > 50 && value <= 75) {
        $variant = 'warning'
      } else if (value > 75 && value <= 100) {
        $variant = 'danger'
      }
      return $variant
    },
    variantLinha (value) {
      return value === 'CREDITO' ? 'info' : value === 'DEBITO' ? 'danger' : ''
    },
    flag (value) {
      return 'flag-icon flag-icon-' + value
    },
    numberToReal (numero) {
      if (!numero) {
        return 'R$ 0,00'
      }
      let n = numero.toFixed(2).split('.')
      n[0] = 'R$ ' + n[0].split(/(?=(?:...)*$)/).join('.')
      return n.join(',')
    },
    listarSaldoContas () {
      let uri = this.$http.defaults.baseURL.concat(`api/protected/caixa/listarmovimentodia?contaid=${this.$route.params.contaid}`)
      let promise = this.$http.get(uri)
      this.tableItemsContas = []
      let saldoAnterior = 0
      let totalCredito = 0
      let totalDebito = 0
      promise.then((data) => {
        if (data) {
          let i
          /*
          let item = {
            avatar: { url: '', status: 'success' },
            user: { name: 'Yiorgos Avraamu', new: true, registered: 'Jan 1, 2015' },
            usage: { value: 50, period: 'Jun 11, 2015 - Jul 10, 2015' },
            activity: '10 sec ago'
          }
          */
          this.saldoInicial = this.numberToReal(data.data[0].SALDO_ANT)
          saldoAnterior += data.data[0].SALDO_ANT
          for (i = 0; i < data.data.length; i++) {
            this.tableItemsContas.push({
              _rowVariant: this.variantLinha(data.data[i].TIPO_MOV),
              historico: { value: data.data[i].NOME_PLANO },
              centrocusto: { value: data.data[i].COD_CENTRO1 },
              obs: { value: data.data[i].OBS },
              tipo: { value: data.data[i].TIPO_MOV },
              credito: { value: this.numberToReal(data.data[i].VL_CREDITO) },
              debito: { value: this.numberToReal(data.data[i].VL_DEBITO) },
              saldo: { value: this.numberToReal(saldoAnterior + data.data[i].VL_CREDITO - data.data[i].VL_DEBITO) }
            })
            totalCredito += data.data[i].VL_CREDITO
            totalDebito += data.data[i].VL_DEBITO
            saldoAnterior = saldoAnterior + data.data[i].VL_CREDITO - data.data[i].VL_DEBITO
            // titulos.push(new Date(data.data[i].DATA).toISOString().substr(0, 10).split('-').reverse().join('/'))
          }
          this.saldoFinal = this.numberToReal(saldoAnterior)
          this.totalCredito = this.numberToReal(totalCredito)
          this.totalDebito = this.numberToReal(totalDebito)
          // this.areceber10DiasTitulos = titulos
        }
      })
    }
  },
  created () {
    this.listarSaldoContas()
  }
}
</script>



// WEBPACK FOOTER //
// src/views/dashboard/CaixaMovimentoDia.vue